import React from 'react';
import { IBaseButtonProps, SubmitButton } from '@alycecom/ui';
import { darken, lighten, useTheme } from '@mui/material';

import { IAlyceCustomTheme } from '../../styles/alyceTheme';

export interface IStyledSubmitButtonProps extends IBaseButtonProps {
  children: React.ReactNode;
}

const StyledSubmitButton = ({ children, ...props }: IStyledSubmitButtonProps): JSX.Element => {
  const {
    palette: { customStyling },
  } = useTheme<IAlyceCustomTheme>();

  return (
    <SubmitButton
      overrideClass="submitButton-ie"
      bgColor={customStyling.primaryColor}
      color={customStyling.primaryCtaColor}
      hoverBgColor={darken(customStyling.primaryColor, 0.2)}
      hoverColor={lighten(customStyling.primaryCtaColor, 0.2)}
      {...props}
    >
      {children}
    </SubmitButton>
  );
};

export default StyledSubmitButton;
